import * as React from 'react';
import { FeatureFlagContext } from '@weddingspot/ws-core-components';
import { useEffect } from 'react';
import { setCurUserProps, UserProp } from '@weddingspot/ws-analytics';
import { FLAG_SHOPPING_CART_FOR_SRP, FLAG_SRP_PRICE_VENUE_CTA } from '@weddingspot/ws-core-components';

const GlobalLogger = () => {
    const { flagEnabled, isInitialized } = React.useContext(FeatureFlagContext);

    useEffect(() => {
        if (isInitialized) {
            setCurUserProps({
                [UserProp.TESTLBL_HOTELS_INTENT_CTA_STEP_REMOVED]: flagEnabled(FLAG_SRP_PRICE_VENUE_CTA)
                    ? 'Intent CTA removed'
                    : 'Intent CTA shown',
                [UserProp.TESTLBL_CHECKOUT_PAGE_FOR_SHOPPING_CART]: flagEnabled('venues_new_checkout_flow')
                    ? 'Couples see the checkout'
                    : 'Couples see the inquiry',
                [UserProp.TESTLBL_SHOPPING_CART_FOR_WEDDING_VENUES]: flagEnabled(FLAG_SHOPPING_CART_FOR_SRP)
                    ? 'Shopping cart shown'
                    : 'Shopping cart hidden',
                [UserProp.TESTLBL_SRP_WITHOUT_FAVORITE_BUTTON]: !flagEnabled('favorite_button_hidden_on_SRP')
                    ? 'Favorite button shown'
                    : 'Favorite button hidden',
            });
        }
    }, [isInitialized]);
    return null;
};

export default GlobalLogger;
